import script from "./FirstExpansionPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstExpansionPanel.vue?vue&type=script&setup=true&lang=js"

import "./FirstExpansionPanel.vue?vue&type=style&index=0&id=36ccd778&lang=css"

const __exports__ = script;

export default __exports__